<ts-link-button
  [text]="linkText"
  (clickFn)="onVenueRequestClick()"
></ts-link-button>
